import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy: React.FC = () => {
  const policySections = [
    {
      title: "1. Information We Collect",
      list: [
        "Personal Identification: Full Name, Email, Phone Number, Date of Birth, Address, PAN, Aadhaar, Employment Information, Bank Account Details, and Financial Data.",
        "Financial Information: Documents such as Bank Statements, Salary Slips, and Consent for Credit Checks are required for loan applications.",
        "Transactional Information: Details about your loans, repayment schedules, and transaction history are recorded.",
      ],
    },
    {
      title: "2. How We Use Your Information",
      list: [
        "Loan Processing: We assess your loan eligibility, process applications, and manage repayments.",
        "Service Improvement: We enhance our platform based on user feedback and interactions.",
        "Communication: We send notifications and respond to inquiries related to our services.",
        "Compliance: We comply with legal requirements like KYC and AML regulations.",
      ],
    },
    {
      title: "3. Sharing Your Information",
      list: [
        "Authorized Third Parties: We work with Credit Bureaus, Payment Gateways, and Verification Agencies to process and verify your information.",
        "Legal Authorities: We may disclose your information as required by the law, such as for regulatory reporting or fraud investigations.",
        `Parent Company: We may share your data with our parent company, ${import.meta.env.VITE_COMPANY_NBFC}, for loan processing.`,
      ],
    },
    {
      title: "4. Data Security",
      content:
        "We employ encryption, secure servers, and multi-factor authentication to safeguard your data. However, no system is 100% secure, and we encourage users to proceed with caution.",
    },
    {
      title: "5. Cookies and Tracking",
      content:
        "We use cookies and tracking technologies to enhance your browsing experience. You can control cookies through browser settings.",
    },
    {
      title: "6. Your Rights",
      content: (
        <>
          You have the right to access, correct, delete, or request portability of
          your data. You can also opt out of marketing communications at any time.
          <br />
          <br />
          For requesting deletion of your personal data, please refer to our{" "}
          <Link
            to="/account-delete-policy"
            className="text-(--primary) hover:underline font-medium"
          >
            User Data Deletion Policy
          </Link>
          .
        </>
      ),
    },

    {
      title: "7. Retention of Information",
      content:
        "We retain your information as long as it is necessary for business or legal reasons, and securely delete it when it is no longer needed.",
    },
    {
      title: "8. Third-Party Links",
      content:
        "Our platform may link to third-party websites. We are not responsible for their privacy practices.",
    },
    {
      title: "9. Children’s Privacy",
      content:
        "We do not knowingly collect data from children under 18. If we find any, we will delete it.",
    },
    {
      title: "10. Policy Updates",
      content:
        "We may update this policy periodically. Check this page for any changes.",
    },
    {
      title: "11. Contact Us",
      list: [
        `Email:${import.meta.env.VITE_COMPANY_EMAIL}`, ,
        `Phone: ${import.meta.env.VITE_COMPANY_PHONE}`,
        `Address: ${import.meta.env.VITE_COMPANY_ADDRESS}`,
      ],
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 lg:py-24 bg-[#EFFFFD]">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C3E50] mb-6 font-['Inter']">
            Privacy <span className="text-[#21A6B5]">Policy</span>
          </h1>
          <p className="text-gray-700 text-base md:text-lg max-w-3xl mx-auto font-['Inter'] leading-relaxed">
            At <span className="font-bold text-[#21A6B5]">MySalaryLoan</span>, we prioritize your privacy. This policy explains how we collect, use, and protect your data.
          </p>
        </div>

        {/* Policy Content */}
        <div className="bg-white rounded-3xl border-2 border-gray-200 shadow-sm p-8 md:p-12 space-y-8">
          {policySections.map((section, idx) => (
            <div key={idx} className="space-y-3">
              <h2 className="text-xl md:text-2xl font-bold text-[#2C3E50] font-['Inter'] border-b-2 border-[#21A6B5]/20 pb-2">
                {section.title}
              </h2>
              {section.content && (
                <div className="text-gray-700 text-base leading-relaxed font-['Inter']">
                  {section.content}
                </div>
              )}
              {section.list && (
                <ul className="list-disc list-outside ml-6 space-y-2 text-gray-700 text-base font-['Inter']">
                  {section.list.map((li, i) => (
                    <li key={i} className="pl-1">{li}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
